export default __webpack_public_path__ + "static/media/wnew4.81e93f32.png";